module.exports = "/wwwroot/img/video_block.png?ver=e95c83af";